import React, { FC, memo, useState } from 'react'

import { FocusNode } from '@please/lrud'
import { scroller } from 'react-scroll'

import { getIsBought } from '@sportworld/js-sdk/src/utils'

import { ContentUnavailable } from '@/components/ContentUnavailable/ContentUnavailable'
import { focusIds } from '@/constants/focus'
import { scrollOptions } from '@/constants/scrollers'
import { SubscriptionItem } from '@/containers/Subscriptions/SubscbriptionItem'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { OfferType } from '@/types/servicesTypes/configTypes'

import {
  ContentUnavailableWrapper,
  StyledElement,
  StyledScrollContainer,
  SubscriptionsContainer,
} from './styles'

const SubscriptionsPanelRaw: FC<{
  offers: Nullable<OfferType[]>
}> = ({ offers }) => {
  const { t } = useCommonTranslation()
  const [defaultFocusChild, setDefaultFocusChild] = useState(0)

  const onMove = (e: MoveEvent) => {
    setDefaultFocusChild(e.nextChildIndex)

    scroller.scrollTo(
      `${focusIds.SUBSCRIPTION}${e.nextChildIndex}`,
      scrollOptions.SubscriptionsPanelScroll,
    )
  }

  return offers?.length ? (
    <FocusNode defaultFocusChild={defaultFocusChild} onMove={onMove}>
      <StyledScrollContainer
        height={scrollOptions.SubscriptionsPanelScroll.height}
        id={scrollOptions.SubscriptionsPanelScroll.containerId}
      >
        <SubscriptionsContainer $centerContent={offers?.length === 1}>
          {offers.map((offer: OfferType, i: number) => {
            const isBought = getIsBought(offer)
            return (
              <StyledElement
                key={`${focusIds.SUBSCRIPTION}${i}`}
                name={`${focusIds.SUBSCRIPTION}${i}`}
              >
                <SubscriptionItem i={i} offer={offer} isBought={isBought} />
              </StyledElement>
            )
          })}
        </SubscriptionsContainer>
      </StyledScrollContainer>
    </FocusNode>
  ) : (
    <ContentUnavailableWrapper>
      <ContentUnavailable>
        {offers ? t('subscriptionUnavailable') : ''}
      </ContentUnavailable>
    </ContentUnavailableWrapper>
  )
}

export const SubscriptionsPanel = memo(SubscriptionsPanelRaw)
